<template>
  <div class="animated fadeIn">
    <div class="service-vouchers-list">
      {{serviceVoucherToDelete}}
      <add-service-voucher v-model="showModal" @serviceVouchersAdded="onServiceVouchersAdd"></add-service-voucher>
      <div>
        <b-modal centered v-model="active" label="Delete" v-if="serviceVoucherToDelete">
          <div>Are you sure you want to delete Service Voucher Id:{{serviceVoucherToDelete.id}}?</div>
          <div slot="modal-footer">
            <b-btn ref="myModalRef" variant="danger" @click="handleConfirm">Confirm</b-btn>
            <b-btn @click="handleCancel">Cancel</b-btn>
          </div>
        </b-modal>
      </div>
      <b-row class="my-2" align-v="center">
        <b-col>
          <b-card head-tag="header">
            <div>
              <v-input-date-range
                label='Filter Service Vouchers by date created'
                :from="filters.datetime.to"
                @inputFrom="(from) => {filters.datetime.from = from}"
                :to="filters.datetime.to"
                @inputTo="(to) => {filters.datetime.to = to}"
                :disabled="isBusy"></v-input-date-range>
            </div>
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong>Filter</strong>
              <div class="card-actions">
                <b-dropdown variant="link" size="sm" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v fa-lg"></i><span class="sr-only">Options</span>
                  </template>
                  <b-dropdown-header>Service Vouchers</b-dropdown-header>
                  <b-dropdown-item @click="showAddServiceVoucherModal">Add Service Voucher</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-card>
        <div class="my-4">
          <div class="my-4">
            <b-row>
              <b-col md="12" class="my-2">
                <!--<b-button-toolbar justify>-->
                <!--<b-input-group class="w-50 mx-1">-->
                <!--<b-form-input :value="filter.q" @blur.native="updateSearch" @keyup.native="updateSearchOnEnterKey" :disabled="isBusy" />-->
                <!--<b-input-group-append>-->
                <!--<b-btn :disabled="!filter.q || isBusy" @click="filter.q = ''">Clear</b-btn>-->
                <!--</b-input-group-append>-->
                <!--</b-input-group>-->
                <b-pagination
                  align="right"
                  class="my-0 mx-1"
                  :disabled="isBusy"
                  :total-rows="meta.total"
                  :per-page="meta.per_page"
                  v-model="meta.current_page"/>
                <!--</b-button-toolbar>-->
              </b-col>
            </b-row>
          </div>
        </div>

        <b-table ref="serviceVouchersList"
                 :outlined="true"
                 head-variant="light"
                 show-empty
                 :busy.sync="isBusy"
                 :items="serviceVouchersProvider"
                 :fields="fields"
                 :filter="filterParams"
                 :current-page="meta.current_page"
                 :per-page="meta.per_page"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 :sort-direction="sortDirection">
          <template slot="service_datetime" slot-scope="row">
            <div>
              {{row.item.service_datetime | moment("dddd, Do MMMM YYYY ")}}
            </div>
          </template>
          <template slot="serviceVouchersTime" slot-scope="row">
            <div>
              {{row.item.service_datetime | moment("hh:mm a")}}
            </div>
          </template>
          <template slot="bookings" slot-scope="row">
            <div>
              <b-btn variant="light" @click.stop="row.toggleDetails"
                     :disabled="(!row.item.bookings || row.item.bookings.length < 1)">
                <span v-if="row.item.bookings">{{row.item.bookings.length}}</span>
                <span class="text-muted" v-else>0</span>
              </b-btn>
            </div>
          </template>
          <template slot="actions" slot-scope="row">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v fa-lg"></i>
              </template>
              <b-dropdown-header>{{row.item.service_datetime | moment("dddd, Do MMMM YYYY hh:mm a")}}
              </b-dropdown-header>
              <b-dropdown-item :to="'/service-vouchers/' + row.item.id + '/edit'">Edit</b-dropdown-item>
              <b-dropdown-item-button @click="confirmDelete(row.item)">Delete</b-dropdown-item-button>
              <b-dropdown-item
                :disabled="(!row.item.bookings || row.item.bookings.length < 1)"
                :href="printURL(row.item.id)"
                target="_blank">Print
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template slot="created_at" slot-scope="row">
            <div>{{row.item.created_at | moment('D/MM/YY')}}</div>
          </template>
          <template slot="from" slot-scope="row">
            <div>{{row.item.from | moment('D/MM/YY')}}</div>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-row>
              <b-col cols="6" lg="4" v-for="(booking, key) in row.item.bookings" :key="key">
                <service-voucher-booking-card :draggable="false" :booking="booking"
                                              :index="(key + 1)"></service-voucher-booking-card>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {serviceVoucherServices} from '../../services'
import AddServiceVoucher from './AddServiceVoucher'
import ServiceVoucherBookingCard from './ServiceVoucherBookingCard'

export default {
  name: 'serviceVouchers',
  data () {
    return {
      active: false,
      serviceVoucherToDelete: null,
      filters: {
        datetime: {
          to: null,
          from: null
        }
      },
      links: {
        next: null,
        prev: null,
        first: null,
        last: null
      },
      meta: {
        current_page: null,
        from: null,
        to: null,
        last_page: null,
        path: null,
        per_page: null,
        total: null
      },
      isBusy: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: {
        q: ''
      },
      fields: [
        { key: 'service_datetime', label: 'Service Vouchers Date', sortable: true },
        { key: 'serviceVouchersTime', label: 'Service Vouchers Time' },
        { key: 'bookings', label: 'Bookings' },
        { key: 'actions', label: '' }
      ],
      showModal: false
    }
  },
  methods: {
    handleDeleteFail () {
      this.isBusy = false
    },
    handleConfirm () {
      console.log(this.serviceVoucherToDelete.id)
      let xhr = this.$store.dispatch('serviceVouchers/destroy', this.serviceVoucherToDelete.id)
      xhr.then(this.handleDeleteSuccess).catch(this.handleDeleteFail)
    },
    handleCancel () {
      this.active = false
    },
    handleDeleteSuccess () {
      this.active = false
      this.getServiceVoucher()
    },
    getServiceVoucher () {
      this.isBusy = true
      let xhr = this.$store.dispatch('serviceVouchers/index')

      xhr.then(
        () => {
          this.isBusy = false
        },
        () => {
          this.isBusy = false
        }
      )
    },
    confirmDelete (serviceVoucher) {
      this.serviceVoucherToDelete = serviceVoucher
      this.active = true
    },
    printURL (serviceVoucherId) {
      let url = serviceVoucherServices.printURL(serviceVoucherId)
      return url + '?token=' + this.accessToken
    },
    serviceVouchersProvider () {
      let filterParams = this.filterParams
      let params = {
        ...JSON.parse(filterParams),
        page: this.meta.current_page || 1
      }

      let xhr = serviceVoucherServices.index(params)

      return xhr.then(this.handleServiceVouchersSuccess, this.handleServiceVouchersFail)
    },
    setLinks (links) {
      if (links) {
        this.$set(this.links, 'first', links.first)
        this.$set(this.links, 'last', links.last)
        this.$set(this.links, 'next', links.next)
        this.$set(this.links, 'prev', links.prev)
      }
    },
    setMeta (meta) {
      if (meta) {
        this.$set(this.meta, 'current_page', meta.current_page)
        this.$set(this.meta, 'from', meta.from)
        this.$set(this.meta, 'to', meta.to)
        this.$set(this.meta, 'last_page', meta.last_page)
        this.$set(this.meta, 'path', meta.path)
        this.$set(this.meta, 'per_page', meta.per_page)
        this.$set(this.meta, 'total', meta.total)
      }
    },
    handleServiceVouchersSuccess (res) {
      if (res.hasOwnProperty('data')) {
        this.setLinks((res.data.hasOwnProperty('links')) ? res.data.links : null)
        this.setMeta((res.data.hasOwnProperty('meta')) ? res.data.meta : null)

        return (res.data.hasOwnProperty('data')) ? res.data.data : []
      } else {
        return []
      }
    },
    handleServiceVouchersFail (e) {
      // TODO: Neil
      console.log(e.response)
    },
    // ServiceVoucher Specific
    showAddServiceVoucherModal () {
      this.showModal = true
    },
    onServiceVouchersAdd (serviceVoucherId) {
      // this.$refs.serviceVouchersList.refresh()
      // console.log(serviceVoucherId)
      this.$router.push({ path: '/service-vouchers/' + serviceVoucherId + '/edit' })
    }
  },
  computed: {
    ...mapGetters(
      'serviceVouchers',
      [
        'serviceVouchers'
      ]
    ),
    ...mapGetters(
      'user',
      [
        'accessToken'
      ]
    ),
    filterParams () {
      let params = {}
      if (this.filters.datetime.from && this.filters.datetime.to) {
        params.datetime = this.filters.datetime.from + ',' + this.filters.datetime.to
      }
      if (this.sortBy) {
        params.sort = this.sortBy
        if (this.sortDesc) {
          params.sort = params.sort + '-'
        }
      }
      return JSON.stringify(params)
    }
  },
  created () {
    this.$store.dispatch('serviceVouchers/index')
  },
  components: {
    AddServiceVoucher,
    ServiceVoucherBookingCard
  }
}
</script>



// WEBPACK FOOTER //
// src/views/serviceVouchers/Index.vue